import { z } from "zod";
import { GenderType } from "../enums/GenderType.js";
import { TargetType } from "../enums/TargetType.js";
import { GeocodeSourceSchema } from "../geo/geocode.model.js";
import { CustomerServiceAddressChangesPayloadSchema } from "./service-address.js";
const optionalText = z.string().nullable().optional();
const optionalCoordinate = z
    .union([
    z.string(),
    z
        .number()
        .finite()
        .transform((value) => String(value)),
])
    .nullable()
    .optional();
export const CreateCustomerTargetPayloadSchema = z.object({
    id: z.string().min(1).optional(),
    label: z.string().optional(),
    index: z.number().int().optional(),
    type: z.nativeEnum(TargetType).optional(),
    gender: z.nativeEnum(GenderType).optional(),
    race: optionalText,
    robe: optionalText,
    height: z.number().finite().nullable().optional(),
    weight: z.number().finite().nullable().optional(),
    birthDate: optionalText,
});
const source = z
    .unknown()
    .transform((value) => {
    if (value === null || value === undefined) {
        return value;
    }
    const parsed = GeocodeSourceSchema.safeParse(value);
    return parsed.success ? parsed.data : undefined;
})
    .optional();
const CustomerPayloadSchema = z.object({
    gender: z.enum(["mr", "mrs"]).nullable().optional(),
    firstName: optionalText,
    familyName: optionalText,
    companyLegalName: optionalText,
    siret: optionalText,
    phone: optionalText,
    email: optionalText,
    facebook: optionalText,
    address: optionalText,
    address2: optionalText,
    city: optionalText,
    zip: optionalText,
    country: optionalText,
    serviceAddress: z.string().min(1).optional(),
    serviceAddress2: optionalText,
    serviceCity: z.string().min(1).optional(),
    serviceZip: z.string().min(1).optional(),
    serviceLong: optionalCoordinate,
    serviceLat: optionalCoordinate,
    serviceGeocodeSource: source,
    serviceTargets: z.array(CreateCustomerTargetPayloadSchema).nullable().optional(),
    serviceAddressChanges: CustomerServiceAddressChangesPayloadSchema.optional(),
});
export const CreateCustomerPayloadSchema = CustomerPayloadSchema.superRefine((value, context) => {
    if (!value.serviceAddressChanges) {
        for (const field of ["serviceAddress", "serviceCity", "serviceZip"]) {
            if (!value[field]) {
                context.addIssue({
                    code: z.ZodIssueCode.custom,
                    path: [field],
                    message: "Adresse de prestation requise.",
                });
            }
        }
    }
});
export const UpdateCustomerPayloadSchema = CustomerPayloadSchema.partial().extend({
    id: z.string().min(1),
    serviceAddress: z.string().optional(),
    serviceCity: z.string().optional(),
    serviceZip: z.string().optional(),
});
//# sourceMappingURL=write-payloads.js.map